var content = require("!!../../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??embedded!../../../../node_modules/.pnpm/sass-loader@8.0.2_sass@1.77.8_webpack@4.42.0/node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-3-2!./theme.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../node_modules/.pnpm/style-loader@1.0.0_webpack@4.42.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
